'use strict';

import { FieldType } from '../../../../../../models/form/fieldType';

export default {
  toolbox: {
    fields: {
      [FieldType.Text]: 'Text',
      [FieldType.LongText]: 'Long Text',
      [FieldType.StaticText]: 'Static Text',
      [FieldType.Datetime]: 'Date/Time',
      [FieldType.Date]: 'Date',
      [FieldType.Time]: 'Time',
      [FieldType.Numeric]: 'Numeric',
      [FieldType.Toggle]: 'Toggle',
      [FieldType.Birthdate]: 'Birthdate',
      [FieldType.CheckBox]: 'Checkbox',
      [FieldType.Acknowledgment]: 'Acknowledgment',
      [FieldType.DocumentViewer]: 'Document Viewer',
      [FieldType.EmailAddress]: 'Email',
      [FieldType.EmbeddedPhoto]: 'Embedded Photo',
      [FieldType.HTML]: 'HTML',
      [FieldType.OptionList]: 'Option List',
      [FieldType.Rating]: 'Rating',
      [FieldType.Select]: 'Select',
      [FieldType.Signature]: 'Signature',
      [FieldType.Video]: 'Video',
      [FieldType.WebLink]: 'Weblink',
      [FieldType.YesNo]: 'Yes/No/NA',
      [FieldType.PaymentZone]: 'Payment zone',
      [FieldType.PaymentOptionList]: 'Payment Option List',
      [FieldType.PaymentChoiceList]: 'Payment Choice List',
      [FieldType.Products]: 'Products',
      [FieldType.UploadFile]: 'Upload File',
    },
    list: {
      text: 'Text',
      toggle: 'Toggle',
      date: 'Date',
      selection: 'Selection',
      embedded: 'Embedded',
      miscellaneous: 'Miscellaneous',
      payment: 'Payment',
    },
    labels: {
      option: 'Option',
      product: 'Product',
    },
  },
};
